import { render, staticRenderFns } from "./FormsSettings.vue?vue&type=template&id=f4d7140a"
import script from "./FormsSettings.vue?vue&type=script&lang=js"
export * from "./FormsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports